// styles.tsx
import { SxProps } from "@mui/material";

export const styles = {
    titleBox: {
        p: 3,
        fontSize: "22px",
        fontWeight: "500",
        lineHeight:"24px "
    } as SxProps,
    containerBox: {
        margin: 1,
        backgroundColor: "white", 
        // marginTop: "10px",
        // padding: "10px",
        minHeight: {
            xs: "auto",  
            sm: "80vh",  
             
          },
          my: "1.2%",
        borderRadius: "5px",
    } as SxProps,
    contentBox: {
        px: 1,
        width: "100%",
    } as SxProps,
    actionBox: {
        display: "flex",
        alignItems: "center",
        gap: 1,
        cursor: "pointer",
    },
    icon: {
        cursor: "pointer",
        width: "16px",
        height: "16px",
    },
    bannerIcon: {
        width: { xs: "60px", sm: "70px", md: "69px" },
        height: { xs: "60px", sm: "70px", md: "69px" },
        borderRadius: "50%",
        objectFit: "cover" as const,
    },
    toolbarContainer: {
        display: "flex",
        flexDirection: { xs: 'column', sm: 'row' },
        justifyContent: "space-between",
        px: 1,
        pt: 2,
        // py: 2,
        alignItems: 'left',
    },
    filterIcon: {
        cursor: "pointer",
        height: "19px",
        width: "32px",
        ":disabled": {
    pointer: "none",
    color: "grey",
  }
    },
    filterBox: {
        display: "flex",
        alignItems: "center",
        gap: 1,
        mt: { xs: 2, sm: 0 },
    },
    filterPopover: {
        ".MuiPopover-paper": {
            width: "40%",
            position: "absolute",  
            overflowY: 'auto',
            my: 2,
            mx: 2,
            zIndex: 1301,
            "@media (max-width: 768px)": {
                width: "88%",
                my: 1,
                mx: 1,
            },
        },
    } as SxProps,
    filterPopoverContainer:
        { p: 2 } as SxProps,
    filterRow: {
        display: "flex",
        mt: 2,
        justifyContent: "space-between",
        flexDirection: {
            xs: "column",
            sm: "row"
        },
    } as SxProps,
    filterFormLeftFields: {
        mt: 2,
        mr: 1,
        width: {
            xs: "100%",
            sm: "70%",
            mr: 1
        },
    } as SxProps,
    filterFormRightFields: {
        mt: 2,
        width: {
            xs: "100%",
            sm: "70%"
        },
    } as SxProps,
    filterSubmitButton: {
        display: "flex",
        justifyContent: "flex-end",
        mt: 6,
    } as SxProps,
    employeeBannerBody:
        {
            display: "grid",
            gridTemplateColumns: {
                xs: "1fr", // Single column for small screens
                sm: "40px repeat(4, 1fr)",
                md: "80px repeat(4, 1fr)", // Original layout for medium and larger screens
            },
            gap: 2,
            alignItems: "top",
            padding: 2,
            textAlign: "left",
            boxShadow: "0px 4px 15px 0px #D8D2FCA3",
            mb: 4,

        } as SxProps,
        avatarBox:{
            gridRow: { xs: "1", sm: "span 2" },
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        } as SxProps,
    
employeeNameBox: 
    {
        display: "flex",
        flexDirection: "column",
        gridRow: { xs: "auto", sm: "span 2" },
        justifyContent: "center",
        alignItems: { xs: "center", sm: "flex-start" },
        textAlign: { xs: "center", sm: "left" },
    } as  SxProps,
    employeeNameText: {
        fontSize: { xs: "18px", sm: "20px" },
        fontWeight: "bold",
    } as  SxProps,
    employeeEmailWordWrap: { wordWrap: "break-word" } as  SxProps,
    employeeProfileBackButton: {
        cursor: 'pointer',
        alignItems: "flex-end",
        textAlign: "right",
        color: 'black',
marginRight: "20px"
     
      } as SxProps,
      mainHeaderBox: {
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
      }as SxProps,
      backButtonBox: {
        width: "20%",
      }as SxProps,
      employeeBannerMainContainer: {
        boxShadow: "0px 4px 15px 0px #D8D2FCA3",
        padding: "10px",
        paddingLeft: "20px",
        paddingRight: "20px",
       
      } as SxProps,
      shiftHistoryText: {
        cursor: 'pointer',
        margin: 0,
      } as SxProps,
      alert:{
        mb: 2,
      }
      ,assignShift: {
        mt: 2,
        display: "flex",
        justifyContent: "flex-end",
      } as SxProps,
      modelRow2: {
        display: "flex",
        flexWrap: "wrap",
      } as SxProps,
      modelRow1: {
        mt: 0.5, 
        display: "flex", 
        flexWrap: "nowrap",  
        gap: 1,
        flexDirection:{xs:"column" , sm:"row"},  
        justifyContent: {xs:"start", sm:"space-between"} 
      } as SxProps,
};
